// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 324) return "static/css/324.94b882b4e98446753456.lib.css";
	if (chunkId === 915) return "static/css/915.531429262a3b9d07f6ed.css";
	// return url for filenames based on template
	return undefined;
};